import { render, staticRenderFns } from "./SubCategoriaCRUD.vue?vue&type=template&id=b13b8a38"
import script from "./SubCategoriaCRUD.vue?vue&type=script&lang=js"
export * from "./SubCategoriaCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports